type GraphicWithShapeKey = {
  attributes?: {
    key?: string
  } | null
}

export const getGraphicShapeKey = (
  graphic: GraphicWithShapeKey | null | undefined
): string | null => {
  if (!graphic) {
    return null
  }

  return graphic.attributes &&
    'key' in graphic.attributes &&
    typeof graphic.attributes.key === 'string'
    ? graphic.attributes.key
    : null
}
